<template>
    <div class="payment-status-chart" :class="{ fullscreen: fullScreen }" v-if="Object.keys(data).length > 0">
        <LineBarChart
            :series="getSeries()"
            :xAxisData="getXAxisData()"
            :yAxis="getYAxis()"
            :colors="['#cb5d0f', '#4213ce', '#c9d906']"
        />
        <BarChart
            v-if="false"
            :series="getSeriesBar()"
            :xAxisData="getXAxisData()"
            :yAxis="getYAxis()"
            :colors="['#cb5d0f', '#4213ce', '#c9d906']"
        />
        <TableView :cols="getCols()" :rows="getRows()" v-if="tableMode" />
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import IconButton from "../../Pages/Settings/components/IconButton.vue";
import LineBarChart from "../../Pages/Chatbot/pages/reports/charts/LineBarChart.vue";
import BarChart from "../../Pages/Chatbot/pages/reports/charts/BarChart.vue";
import StatCard from "../../Pages/Chatbot/pages/reports/charts/StatCard.vue";
import TableView from "../../Pages/Chatbot/pages/reports/charts/TableView.vue";
import { expertToExcel } from "../../../utils/utils";
import { ADMIN_REPORT_API } from "../../../api/statistics";
import log2 from "../../../utils/log2";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import fscreen from "fscreen";

const log = log2("PaymentStatusChart");
export default Vue.extend({
    name: "PaymentStatusChart",
    components: { ChartDoddleIcon, TableView, IconButton, StatCard, LineBarChart, BarChart },
    props: {
        filters: {
            type: Object,
            default: () => ({
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            colors: ["#FFBF00"],
            stats: {
                totalPaidPrice: 0,
                totalUnpaidPrice: 0,
            },
            tableMode: false,
            loading: true,
            loadingInstance: null,
            data: {},
            fullScreen: false,
            cancels: [],
        };
    },
    methods: {
        getYAxis() {
            console.log("getYAxis worked..", this.data);

            const paidPriceData = this.data.buckets.map((item) => item.paidPrice);
            const unpaidPriceData = this.data.buckets.map((item) => item.unpaidPrice);
            const maxValue = Math.max(Math.max(paidPriceData), Math.max(unpaidPriceData));
            const minValue = Math.min(Math.min(paidPriceData), Math.min(unpaidPriceData));
            console.log("getYAxis..", { maxValue, minValue });
            return [
                {
                    type: "value",
                    name: "Price",
                    min: minValue,
                    max: maxValue,
                    interval: 50,
                    axisLabel: {
                        formatter: "{value} ₺",
                    },
                },
                {
                    type: "value",
                    name: "Price",
                    min: minValue,
                    max: maxValue,
                    interval: 5,
                    axisLabel: {
                        formatter: "{value} ₺",
                    },
                },
            ];
        },
        getXAxisData() {
            if (Object.keys(this.data).length === 0) return [];
            const { buckets, timeSeriesType } = this.data;
            const test = buckets.map((item) => {
                if (timeSeriesType === "day") {
                    return moment(item.date).format("DD/MM");
                } else if (timeSeriesType === "hour") {
                    return moment(item.date).format("HH:mm");
                } else if (timeSeriesType === "week") {
                    return moment(item.date).format("YYYY-WW[week]");
                } else {
                    //monthly
                    return moment(item.date).format("MMM");
                }
            });
            console.log("getXAxisData test", test);
            return test;
        },
        switchToFullScreenMode() {
            if (this.fullScreen) {
                this.closeFullScreenMode();
            } else {
                const elem = document.querySelector(".payment-status-chart");
                fscreen.requestFullscreen(elem);
                this.fullScreen = true;
            }
        },
        closeFullScreenMode() {
            fscreen.exitFullscreen();
        },
        fetch() {
            this.loading = true;
            this.loadingInstance.show();
            ADMIN_REPORT_API.paymentStatusSites(this.filters)
                .then((res) => {
                    log("paymentStatusSites data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getCols() {
            return [
                {
                    key: "paymentMethod",
                    field: "paymentMethod",
                    title: "Ödeme Yöntemi",
                },
                {
                    key: "siteCount",
                    field: "siteCount",
                    title: this.$t("report.siteCount"),
                },
            ];
        },
        getRows() {
            const rows = this.data.map((item) => {
                return [item.paymentMethod, item.siteCount];
            });
            return rows;
        },
        getStats() {
            const data = _.get(this.data, "buckets", []);
            return {
                totalPaidPrice: data.map((item) => item.paidPrice).reduce((a, b) => a + b, 0),
                totalUnpaidPrice: data.map((item) => item.unpaidPrice).reduce((a, b) => a + b, 0),
            };
        },
        getSeries() {
            const data = _.get(this.data, "buckets", []);

            const totalPaidPrice = data.map((item) => item.paidPrice);
            const totalUnpaidPrice = data.map((item) => item.unpaidPrice);
            const totalPrice = data.map((item) => item.paidPrice + item.unpaidPrice);

            return [
                {
                    name: "TotalPriceData",
                    type: "bar",
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + " ₺";
                        },
                    },
                    data: totalPrice,
                },
                {
                    name: "TotalPaidPriceData",
                    type: "line",
                    yAxisIndex: 1,
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + " ₺";
                        },
                    },
                    data: totalPaidPrice,
                },
                {
                    name: "TotalUnPaidPriceData",
                    type: "line",
                    yAxisIndex: 1,
                    tooltip: {
                        valueFormatter: function (value) {
                            return value + " ₺";
                        },
                    },
                    data: totalUnpaidPrice,
                },
            ];
        },
        getSeriesBar() {
            const totalPaidPrice = this.data.buckets.map((item) => item.paidPrice);
            const totalUnpaidPrice = this.data.buckets.map((item) => item.unpaidPrice);
            const totalPrice = this.data.buckets.map((item) => item.paidPrice + item.unpaidPrice);

            const rawData = [totalUnpaidPrice, totalPaidPrice];
            const totalData = [];
            for (let i = 0; i < rawData[0].length; ++i) {
                let sum = 0;
                for (let j = 0; j < rawData.length; ++j) {
                    sum += rawData[j][i];
                }
                totalData.push(sum);
            }
            return ["Unpaid", "Paid"].map((name, sid) => {
                return {
                    name,
                    type: "bar",
                    stack: "total",
                    barWidth: "60%",
                    label: {
                        show: true,
                        formatter: (params) => Math.round(params.value * 1000) / 10 + "%",
                    },
                    data: rawData[sid].map((d, did) => (totalData[did] <= 0 ? 0 : d / totalData[did])),
                };
            });
        },
        exportToExcel() {
            const data = this.data.map((item) => {
                return [item.siteCount, item.paymentMethod];
            });
            const stats = this.getStats();
            const excelData = [
                ...data,
                {
                    date: "Toplam site",
                    siteCount: stats.TotalSiteCount,
                },
                {
                    date: "Ödeme Yöntemi",
                    siteCount: stats.paymentMethods,
                },
            ];
            expertToExcel(excelData, `site_payment-methods_.xlsx`, "Sheet 1");
        },
    },
    created() {
        const fullscreenCallback = () => {
            console.log("fullscreenCallback", fscreen.fullscreenElement);
            this.fullScreen = fscreen.fullscreenElement !== null;
            this.$forceUpdate();
        };
        fscreen.addEventListener("fullscreenchange", fullscreenCallback);
        this.cancels.push(() => {
            fscreen.removeEventListener("fullscreenchange", fullscreenCallback);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".payment-status-chart"),
            name: "wave",
        });
        this.stats = this.getStats();
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
        data: {
            handler: function (val, oldVal) {
                this.stats = this.getStats();
            },
            deep: true,
        },
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
    },
});
</script>
<style lang="scss">
.payment-status-chart {
    .title {
        display: flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        margin: 0;

        h2 {
            text-align: center;
            font-weight: 700;
            font-size: 40px;
            margin: 0 !important;
        }
    }

    &.fullscreen {
        background-color: #fff;
        padding: 20px;
        overflow-y: scroll;

        .stacked-area-chart {
            height: calc(100vh - 200px);
        }
    }
}
</style>
<style scoped lang="scss">
.payment-status-chart {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .toolbar {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;

            .buttons {
                display: flex;
                border: 1px solid var(--color-border-default);

                .icon-button {
                    padding: 5px;
                    width: 40px;
                    height: 34px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid var(--color-border-default);
                    border-radius: unset !important;

                    &.selected {
                        background-color: var(--color-bg-info-low-hover);

                        i {
                            color: rgb(55, 162, 255);
                        }
                    }

                    &:hover {
                        background-color: var(--color-bg-neutral-pressed);
                    }
                }

                .icon-button:last-child {
                    border-right: none;
                }
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
        }
    }

    .stats {
        display: flex;
        flex-direction: row;
        gap: 10px;
        flex-wrap: wrap;
    }
}
</style>
